import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface SearchBannerContainerProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element
    $paddingTop: string
    $copyOnly: boolean
}

const SearchBannerContainer = memo(
    ({templating, children, $paddingTop = "0", $copyOnly}: SearchBannerContainerProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)

        return (
            <ComponentName $paddingTop={$paddingTop} $copyOnly={$copyOnly}>
                {children}
            </ComponentName>
        )
    },
)
SearchBannerContainer.displayName = "SearchBannerContainer"

export default connect(SearchBannerContainer)
